import * as React from 'react';
import { ModulesBasic, IPropsBasic, ModulesRoot } from 'kts-scaffold-framework/modules';
import { connect } from 'kts-platform-frame/redux';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
import ModulesRoute, { Switch } from './Modules.Route';

/** Redux接口 */
interface IReduxStatePart {
}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {   
}

/** 收件箱 */
@connect((state: ReduxState): IReduxStatePart => ({
}))
export default class InBox extends ModulesBasic<IProps, ModulesState> {

    public state: ModulesState = new ModulesState();

    constructor(props: IProps) {
        super(props, ModulesAction);
    }

    render() {
        return (
            <ModulesRoot action={ModulesAction}>
                <Switch>
                    {ModulesRoute.getChildReact('/workbench/platform/appStore/appManage')}
                    {ModulesRoute.getChildReact('/workbench/platform/appStore/appManage/AppBatchActivated')}
                </Switch>
            </ModulesRoot>
        );
    }
}


// WEBPACK FOOTER //
// ./src/display/platform/AppStore/index.tsx